var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvalanche = function SvgAvalanche(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u5E01\u79CD\u5907\u4EFD 2")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u57FA\\u7840\\u670D\\u52A1\\uFF081117\\u66F4\\u65B0\\uFF09",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5E01\\u79CD\\u5907\\u4EFD-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#E84142",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "\\u8DEF\\u5F84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51363108,13 L1.15960067,13 C0.664946832,13 0.420612287,13 0.271614013,12.9001615 C0.110719232,12.7911601 0.0123723422,12.6101909 0.000457589205,12.410743 C-0.00848303711,12.226815 0.113693358,12.0023407 0.358027903,11.5534302 L6.1704203,0.83471072 C6.41774722,0.379558003 6.54289774,0.1519721 6.70083664,0.0678061674 C6.87067205,-0.0226020558 7.07329583,-0.0226020558 7.24314949,0.0678061674 C7.40108839,0.1519721 7.52623891,0.379558003 7.77354758,0.83471072 L8.96845316,3.01699266 C9.23960959,3.51267254 9.37667486,3.76207783 9.43628512,4.0239486 C9.50182538,4.30763877 9.50182538,4.60692511 9.43628512,4.89061527 C9.37667486,5.15248605 9.24258371,5.40189134 8.97142729,5.89757122 L5.91831288,11.5440764 C5.64418233,12.0459985 5.50711706,12.2985154 5.31640802,12.4885903 C5.11079187,12.6943759 4.86348319,12.8440382 4.59230852,12.9282232 C4.34499985,13 4.06787693,13 3.51363108,13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8314423,13 L9.45829001,13 C8.96066205,13 8.710361,13 8.5643551,12.9003524 C8.40344207,12.7911601 8.30511343,12.6071366 8.29319868,12.4077078 C8.28425805,12.2237606 8.40940857,11.9993054 8.65970962,11.5472643 L10.3432113,8.52326579 C10.5906295,8.07746696 10.7157982,7.85612335 10.8707083,7.77193833 C11.0405802,7.6815301 11.2401933,7.6815301 11.4100652,7.77193833 C11.5680771,7.85612335 11.690144,8.07746696 11.9404816,8.52015419 L13.6300775,11.5441527 C13.8802326,11.9961938 14.0085032,12.220649 13.9995625,12.4045771 C13.9906219,12.6040822 13.8891732,12.7881057 13.7284244,12.8971072 C13.5793531,13 13.3290156,13 12.8314423,13 Z"
  })))))));
};

export { SvgAvalanche as ReactComponent };
export default __webpack_public_path__ + "daf29ef0e916d5a5e70788ba16070e3b.svg";